import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import { l, k, c, b, d, e, f, g } from './chunk-DCAKKOYV.js';
var m = /*#__PURE__*/function () {
  function m() {
    _classCallCheck(this, m);
    _defineProperty(this, "_dotLottie", void 0);
    _defineProperty(this, "_animationsMap", new Map());
    _defineProperty(this, "_themeMap", new Map());
    _defineProperty(this, "_stateMachinesMap", new Map());
    _defineProperty(this, "_manifest", void 0);
  }
  return _createClass(m, [{
    key: "dotLottie",
    get: function get() {
      return this._dotLottie;
    }
  }, {
    key: "animationsMap",
    get: function get() {
      return this._animationsMap;
    }
  }, {
    key: "themeMap",
    get: function get() {
      return this._themeMap;
    }
  }, {
    key: "stateMachinesMap",
    get: function get() {
      return this._stateMachinesMap;
    }
  }, {
    key: "manifest",
    get: function get() {
      return this._manifest;
    }
  }, {
    key: "loadFromUrl",
    value: function () {
      var _loadFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(i) {
        var t, a, _e, n, p, _e2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(i, {
                method: "GET",
                mode: "cors"
              });
            case 2:
              t = _context.sent;
              if (t.ok) {
                _context.next = 5;
                break;
              }
              throw new Error("Failed to load dotLottie from ".concat(i, " with status ").concat(t.status));
            case 5:
              a = t.headers.get("content-type");
              if (!(a != null && a.includes("application/json"))) {
                _context.next = 18;
                break;
              }
              _context.next = 9;
              return t.json();
            case 9:
              _e = _context.sent;
              if (l(_e)) {
                _context.next = 12;
                break;
              }
              throw new Error("Invalid lottie JSON at ".concat(i));
            case 12:
              n = k(i);
              this._animationsMap.set(n, _e);
              p = {
                activeAnimationId: n,
                animations: [{
                  id: n
                }]
              };
              this._manifest = p;
              _context.next = 31;
              break;
            case 18:
              _context.t0 = c;
              _context.next = 21;
              return t.arrayBuffer();
            case 21:
              _context.t1 = _context.sent;
              _context.next = 24;
              return (0, _context.t0)(_context.t1);
            case 24:
              this._dotLottie = _context.sent;
              _context.next = 27;
              return b(this._dotLottie);
            case 27:
              _e2 = _context.sent;
              if (_e2) {
                _context.next = 30;
                break;
              }
              throw new Error("Manifest not found");
            case 30:
              this._manifest = _e2;
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadFromUrl(_x) {
        return _loadFromUrl.apply(this, arguments);
      }
      return loadFromUrl;
    }()
  }, {
    key: "loadFromLottieJSON",
    value: function loadFromLottieJSON(i) {
      if (!l(i)) throw new Error("Invalid lottie JSON");
      var t = "my-animation";
      this._animationsMap.set(t, i);
      var a = {
        activeAnimationId: t,
        animations: [{
          id: t
        }]
      };
      this._manifest = a;
    }
  }, {
    key: "loadFromArrayBuffer",
    value: function () {
      var _loadFromArrayBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(i) {
        var t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return c(i);
            case 2:
              this._dotLottie = _context2.sent;
              _context2.next = 5;
              return b(this._dotLottie);
            case 5:
              t = _context2.sent;
              if (t) {
                _context2.next = 8;
                break;
              }
              throw new Error("Manifest not found");
            case 8:
              this._manifest = t;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadFromArrayBuffer(_x2) {
        return _loadFromArrayBuffer.apply(this, arguments);
      }
      return loadFromArrayBuffer;
    }()
  }, {
    key: "getAnimation",
    value: function () {
      var _getAnimation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(i) {
        var t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this._animationsMap.get(i)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", this._animationsMap.get(i));
            case 2:
              if (this._dotLottie) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _context3.next = 6;
              return d(this._dotLottie, i, {
                inlineAssets: !0
              });
            case 6:
              t = _context3.sent;
              return _context3.abrupt("return", (t && this._animationsMap.set(i, t), t));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAnimation(_x3) {
        return _getAnimation.apply(this, arguments);
      }
      return getAnimation;
    }()
  }, {
    key: "getTheme",
    value: function () {
      var _getTheme = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(i) {
        var t;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this._themeMap.get(i)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", this._themeMap.get(i));
            case 2:
              if (this._dotLottie) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return e(this._dotLottie, i);
            case 6:
              t = _context4.sent;
              return _context4.abrupt("return", (t && this._themeMap.set(i, t), t));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getTheme(_x4) {
        return _getTheme.apply(this, arguments);
      }
      return getTheme;
    }()
  }, {
    key: "getStateMachines",
    value: function () {
      var _getStateMachines = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var i, t, a, _e3, n;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this._dotLottie) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return f(this._dotLottie);
            case 4:
              i = _context5.sent;
              for (t in i) if (t) {
                a = i[t];
                if (a) {
                  _e3 = JSON.parse(a);
                  if (_e3) {
                    n = _e3.descriptor.id;
                    this._stateMachinesMap.get(n) || this._stateMachinesMap.set(n, _e3);
                  }
                }
              }
              return _context5.abrupt("return", Array.from(this._stateMachinesMap.values()));
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getStateMachines() {
        return _getStateMachines.apply(this, arguments);
      }
      return getStateMachines;
    }()
  }, {
    key: "getStateMachine",
    value: function () {
      var _getStateMachine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(i) {
        var t;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this._stateMachinesMap.get(i)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", this._stateMachinesMap.get(i));
            case 2:
              if (this._dotLottie) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return");
            case 4:
              _context6.next = 6;
              return g(this._dotLottie, i);
            case 6:
              t = _context6.sent;
              return _context6.abrupt("return", (t && this._stateMachinesMap.set(t.descriptor.id, t), t));
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getStateMachine(_x5) {
        return _getStateMachine.apply(this, arguments);
      }
      return getStateMachine;
    }()
  }]);
}();
export { m as a };